<script setup lang="ts">
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
import { Sheet as BottomSheet } from 'bottom-sheet-vue3'
import UiPanelHeader from './UiPanelHeader.vue'
import { useAppMode } from '@/composables/useAppMode'

defineOptions({
  inheritAttrs: false
})

const props = withDefaults(
  defineProps<{
    title?: string
    tag?: string
    onClose?: () => void
    onBack?: () => void
    showBackLabel?: boolean
  }>(),
  { tag: 'div', preferBottomSheet: false }
)

const emit = defineEmits<{
  close: []
  back: []
}>()

const { mode } = useAppMode()
</script>

<template>
  <component
    :is="tag"
    class="panel relative px-5 py-15 lg:px-12"
    :class="`panel--${mode}`"
    v-bind="$attrs"
  >
    <slot name="header">
      <ui-panel-header v-if="title" @close="$props.onClose" @back="$props.onBack">
        {{ title }}
      </ui-panel-header>
    </slot>
    <perfect-scrollbar class="panel__content px-3">
      <slot />
    </perfect-scrollbar>
  </component>
</template>

<style lang="scss">
:root {
  /* var(--app-panel-background-color, #1f212e); */
  --bottom-sheet-bakground-color: #0d1526;
  --bottom-sheet-max-height: 90%;
}

.panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #0d1526;
  overflow: hidden;

  &--desktop {
    width: 375px;
    max-width: 90dvw;
    max-height: 90dvh;
    border-radius: 12px;
  }

  &--mobile {
    border-radius: 8px;
    max-height: 90dvh;
  }

  &__bottom-sheet-header {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;

    &-bar {
      width: 36px;
      height: 4px;
      margin-top: 10px;
      margin-bottom: -10px;
      background-color: var(--bottom-sheet-header-bar-background-color, rgb(88, 88, 88));
      border-radius: var(--bottom-sheet-header-bar-border-radius, 10px);
    }
  }

  &__title {
    position: relative;
    width: 100%;
    color: var(--wpt-text-white, #fff);
    text-align: center;
    font-size: 16px;
    font-weight: 500;

    &-content {
      padding: 14px 0;
    }

    &-separator {
      margin: 0 20px;
      border: none;
      border-bottom: 1px solid #303144;
    }
  }

  &__content {
    padding: 20px 16px;
    width: 100%;
    flex: 1;

    display: inline-flex;
    overflow: hidden;
    flex-direction: column;
    gap: 20px;

    color: #86899e;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }

  &__close {
    position: absolute;
    right: 13px;
    top: 13px;
    padding: 8px;
    background-color: transparent;
    border: none;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
  }

  &__back {
    display: flex;
    align-items: center;
    color: white;
    position: absolute;
    left: 13px;
    top: 12px;
    padding: 8px;
    background-color: transparent;
    border: none;
    cursor: pointer;
  }
}

.panel--desktop {
  width: 554px;
  max-width: 90dvw;
  max-height: 90dvh;
  border-radius: 12px;
}

.panel--mobile {
  border-radius: 8px;
  /* max-width: 95vw; */
  max-height: 90dvh;
}

.panel__title {
  position: relative;
  width: 100%;
  color: var(--wpt-text-white, #fff);
  text-align: center;
  font-size: 16px;

  font-weight: 500;
}

.panel__title-content {
  padding: 14px 0;
}

.panel__title-separator {
  margin: 0 20px;
  border: none;
  border-bottom: 1px solid #303144;
}

.panel__content {
  padding-top: 20px;
  width: 100%;
  flex: 1;

  display: inline-flex;
  overflow: hidden;
  flex-direction: column;
  gap: 20px;

  color: #86899e;
  font-size: 14px;
  font-style: normal;
  line-height: 20px; /* 166.667% */
}

.panel__close {
  position: absolute;
  right: 13px;
  top: 13px;
  padding: 8px;
  background-color: transparent;
  border: none;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
}

.panel__back {
  display: flex;
  align-items: center;

  color: white;
  position: absolute;
  left: 13px;
  top: 12px;
  padding: 8px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.bottom-sheet-header-bar {
  width: 10%;
  height: 4px;
  background-color: var(--bottom-sheet-header-bar-background-color, #2e313e);
}
</style>
